__turbopack_context__.v({
  "track-list-component": "track-list-component-module-scss-module__xz-ZAq__track-list-component",
  "track-list-component__disc": "track-list-component-module-scss-module__xz-ZAq__track-list-component__disc",
  "track-list-component__disc-number": "track-list-component-module-scss-module__xz-ZAq__track-list-component__disc-number",
});
